const nameValidation = (name: string) => {
	if (name === "") return true;
	// Valida que el nombre no contenga caracteres especiales pero si acepta -, _, espacios, tildes, números y la letra ñ
	const regex = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ0-9\s_-]*$/;
	// Verifica que la expresión regular sea válida Y que el nombre no sea solo espacios
	return regex.test(name) && name.trim().length > 0;
};

const normalizeString = (str: string) => {
	if (typeof str !== 'string') return str;
	return str
		.normalize("NFD") // Descompone letras con tilde en letra + tilde
		.replace(/[\u0300-\u036f]/g, "") // Elimina los caracteres diacríticos
		.toLowerCase() // Convierte todo a minúsculas
		.trim(); // Elimina espacios al inicio/final
};

const compareObjects = (obj1: Object, obj2: Object) => {
	console.log("Comparing objects:", obj1, obj2);
	return JSON.stringify(obj1) === JSON.stringify(obj2);
};

/**
 * Compara dos cadenas de tiempo en formato HH:MM
 * @param time1 HH:mm
 * @param time2 HH:mm
 * @returns 0 si son iguales, -1 si time1 es menor, 1 si time1 es mayor
 */
const compareTimeStrings = (time1: string, time2: string) => {
	if (time1.length !== 5 || time2.length !== 5) return 0;

	const [hours1, minutes1] = time1.split(':').map(Number);
	const [hours2, minutes2] = time2.split(':').map(Number);

	const totalMinutes1 = hours1 * 60 + minutes1;
	const totalMinutes2 = hours2 * 60 + minutes2;

	return totalMinutes1 - totalMinutes2;
};

export { nameValidation, normalizeString, compareObjects, compareTimeStrings };
